import {createStore, combineReducers} from 'redux';
import paramsReducer from './params/reducer';

const reducers = combineReducers({
  paramsReducer
});

const store = createStore(
  reducers
);

export default store
